"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCloudConfig = void 0;
var DeviceCharacteristic_1 = require("../../../common/DeviceCharacteristic");
var dataViewParsers_1 = require("../parsers/dataViewParsers");
// eslint-disable-next-line import/prefer-default-export
var setCloudConfig = function (device, powerLevel, batterySavingEnabled, batterySavingThresholdValue, batterySavingPowerLevel, batterySavingOn, withResponse) {
    var value = new Uint8Array(batterySavingEnabled != undefined ? 5 : 1);
    if (value.length > 1) {
        value.set([powerLevel, batterySavingEnabled, batterySavingThresholdValue, batterySavingPowerLevel, batterySavingOn]);
    }
    else {
        value.set([powerLevel]);
    }
    return device
        .writeCharacteristicValues(device.profile.VAPING.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.VapingCharacteristics.CLOUD_CONTROL; }).uuid, value, withResponse)
        .then(function (res) { return (0, dataViewParsers_1.parseCloudInfo)(res); });
};
exports.setCloudConfig = setCloudConfig;
